import { message } from 'antd';
import SettingAPI from '../restAPI/SettingAPI';
import {
  getIsSoPortalGroupAdminFromToken,
  getRoleNameFromToken,
  resolveAuthToken,
} from './subscriptionPlan';

export const usesManageProfileLinkForSelfOnboarding = (roleName, token) => {
  const authToken = resolveAuthToken(token);
  const resolvedRole = roleName ?? getRoleNameFromToken(authToken);
  return (
    resolvedRole === 'Group Admin' &&
    getIsSoPortalGroupAdminFromToken(authToken)
  );
};

export async function openManageProfileLink(token) {
  const authToken = resolveAuthToken(token);
  if (!authToken) {
    message.error('Unable to open portal. Please sign in again.');
    return false;
  }

  if (!usesManageProfileLinkForSelfOnboarding(null, authToken)) {
    message.error('You do not have access to the Self Onboarding Portal.');
    return false;
  }

  const groupIdHeader = localStorage.getItem('groupId');
  const companyIdHeader = localStorage.getItem('companyId');

  try {
    const res = await SettingAPI.getManageProfileLink(
      authToken,
      groupIdHeader,
      companyIdHeader
    );
    const redirectUrl = res?.data?.redirect_url;
    if (redirectUrl) {
      window.open(redirectUrl, '_blank', 'noopener,noreferrer');
      return true;
    }
    message.error('Portal link is unavailable right now.');
    return false;
  } catch (err) {
    message.error(
      err?.response?.data?.message || 'Unable to open portal right now.'
    );
    return false;
  }
}
